import {
  Button,
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
  Spinner,
} from '@design-system';

import { Building2, X } from 'lucide-react';

import { useCcrcTypeAFlow } from '../hooks/use-ccrc-type-a-flow';
import { CcrcTypeAProductOptions } from './ccrc-type-a-product-options';

export function CcrcTypeAPageContent({ clientId }: ClientIdProps) {
  const { products, client, partner, isLoading, isError, handleAddPlan, onClose } =
    useCcrcTypeAFlow(clientId);

  const hasProducts = products.length > 0;

  return (
    <div className="bg-background relative flex min-h-screen flex-col">
      <div className="border-border bg-background sticky top-0 z-40 shrink-0 border-b px-4">
        <div className="mx-auto w-full max-w-7xl py-4">
          <div className="flex items-start justify-between">
            <div className="text-left">
              <h1 className="text-primary-dark text-lg font-semibold md:text-xl">
                Add a Life Planning Community Product
              </h1>
              <p className="text-foreground max-w-3xl text-balance text-sm md:text-base">
                Model a Life Planning Community, CCRC, or CCAH Type A Plan. These plans typically
                cover all LTC expenses for a one-time entry and recurring maintenance fee.
              </p>
            </div>
            <Button
              variant="outline"
              size="icon-sm"
              onClick={onClose}
              aria-label="Close"
              className="rounded-full"
            >
              <X />
            </Button>
          </div>
        </div>
      </div>

      <div className="w-full px-4 py-10">
        <div className="mx-auto w-full max-w-7xl">
          {isLoading && (
            <div className="py-16">
              <Spinner className="text-primary mx-auto size-8" />
            </div>
          )}

          {!isLoading && (isError || !hasProducts) && (
            <Empty className="w-full border">
              <EmptyHeader>
                <EmptyMedia variant="icon">
                  <Building2 />
                </EmptyMedia>
                <EmptyTitle>No Type A products available</EmptyTitle>
                <EmptyDescription>
                  There are no Type A plans to show right now. Head back to choose another way to
                  fund care.
                </EmptyDescription>
              </EmptyHeader>
              <EmptyContent>
                <Button
                  variant="outline"
                  onClick={onClose}
                >
                  Back to Funding Options
                </Button>
              </EmptyContent>
            </Empty>
          )}

          {!isLoading && hasProducts && (
            <CcrcTypeAProductOptions
              products={products}
              client={client}
              partner={partner}
              onSelect={handleAddPlan}
            />
          )}
        </div>
      </div>
    </div>
  );
}
